import { call, fork, select, takeLatest } from 'redux-saga/effects';

import { fetchSpecialties } from '../api'

import { specialtiesListActions } from './actions';
import { getSpecialtiesListsById } from './selectors';

export function* loadSpecialtiesList({payload}) {

  const { id, sessionId } = payload;
  const specialtiesList = yield select(getSpecialtiesListsById, id);

  if (!specialtiesList) {
    yield call(fetchSpecialties, id, { sessionId });
  }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadSpecialties() {
  yield takeLatest(specialtiesListActions.LOAD_SPECIALTIES, loadSpecialtiesList);
}

//=====================================
//  ROOT
//-------------------------------------

export const specialtiesListSagas = [
  fork(watchLoadSpecialties),
];
